module.exports = __webpack_public_path__ + "img/logo-sm.0c531d70.svg";